import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';

function ReportsIcon(props) {
  const {
    color,
    ...svgProps
  } = props;

  return (
    <svg
      {...svgProps}
      viewBox="-4 0 26 22"
      role="presentation"
    >
      <g fill={color} fillRule="evenodd" >
        <rect x=".049" y="8.622" width=".677" height="13.37" rx=".339" />
        <rect x="6.155" y="5.551" width=".677" height="16.441" rx=".339" />
        <rect x="18.367" y="3.44" width=".797" height="18.552" rx=".399" />
        <rect x="12.261" y=".05" width=".677" height="21.942" rx=".339" />
      </g>
    </svg>
  );
}

ReportsIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

ReportsIcon.defaultProps = {
  height: 22,
  width: 20,
};

export default pure(ReportsIcon);
